import { render, staticRenderFns } from "./registerAgreement.vue?vue&type=template&id=656ff21c&scoped=true"
import script from "./registerAgreement.vue?vue&type=script&lang=js"
export * from "./registerAgreement.vue?vue&type=script&lang=js"
import style0 from "./registerAgreement.vue?vue&type=style&index=0&id=656ff21c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656ff21c",
  null
  
)

export default component.exports